import LabelFlair from './components/LabelFlair';

export {LabelFlair};



// WEBPACK FOOTER //
// ./src/components/flairs/index.jsx